module.exports = __webpack_public_path__ + "img/discover.fc1d0b78.svg";